import { render } from "./PreviewResourceModal.vue?vue&type=template&id=2914d4db"
import script from "./PreviewResourceModal.vue?vue&type=script&lang=js"
export * from "./PreviewResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PreviewResourceModal.vue"]])

export default __exports__